export default __webpack_public_path__ + "static/media/archi_view4.1937b924.webp";